<template>
  <div>
    <mt-header title="实名认证" style="position:fixed;top:0;width:100%;z-index:1000;">
      <div @click="$router.push('/certification')" slot="left">
        <mt-button icon="back"></mt-button>
      </div>
    </mt-header>
    <div style="padding:10px;">
      <div class="wish">恭喜，您已经通过实名认证！</div>
      <div  class="userinfo">
        <div>认证身份：<span>{{identity}}</span></div>
        <div>真实姓名：<span>{{realName}}</span></div>
        <div>身份证号码：<span>{{IDnumber}}</span></div>
        <div>证件有效期：<span>{{effective}}</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'realNameSuccess',
  data(){
    return {
      identity:'',
      realName:'',
      IDnumber:'',
      effective:'',
    }
  },
  created(){
    this.$emit('footer', false);
  },
  mounted(){
    this.getAccInformation()
  },
  methods:{
    //获取用户基本信息
    getAccInformation(){
      let _this = this
      _this.axios({
        method: 'GET',
        url: '/url/account/userInfo/getUserInformationById',
        params: {id:sessionStorage.getItem('loginId')},
      }).then(function (res) {

        if (res.data.accountCertificate) {
          var dataname = res.data.accountCertificate.name.split("").map((item,index)=>{
              if(index>0){
                  return "*"
              }else{
                  return item
              }
          })
          var name = dataname.join("");
          var num = res.data.accountCertificate.idCardNo
          var number = num.substr(0, 2) + "**************" + num.substr(16, 18);
          var validity = res.data.accountCertificate.idCardValidity.split("-")[1]

          _this.identity = '个人'
          _this.realName = name
          _this.IDnumber = number
          _this.effective = validity

        }
      })
    }
  }
}
</script>
<style scoped>
.wish{
  color: #67c23a;
  font-weight: bold;
  font-size: 22px;
  margin-top: 16vh;
  text-align: center;
}
.userinfo{
  font-size: 16px;
  padding: 20px 0 0 50px;
  line-height: 2;
}
</style>



// WEBPACK FOOTER //
// realNameSuccess.vue?22e1f974